import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

interface ModuleTitleWrapperProps {
  color?: string;
  marginBottom: string;
}

export const ModuleTitleWrapper = styled.div<ModuleTitleWrapperProps>`
  margin-bottom: ${(props) => props.marginBottom};

  .title {
    color: ${(props) => props.color || '#333f48'};
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 4px;
    font-weight: 500;
    @media (${mediaQuery.mobile}) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  .subtitle {
    color: ${(props) => props.color || '#333f48'};
    font-size: 16px;
    line-height: 26px;
    font-weight: 300;
    margin-bottom: 0;
  }
`;
